import { render, staticRenderFns } from "./UserProfileCoursesIndex.vue?vue&type=template&id=38666725"
import script from "./UserProfileCoursesIndex.vue?vue&type=script&lang=js"
export * from "./UserProfileCoursesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports